// Вход приложения: роутер, заголовки страниц, окружение Telegram, PWA и экранов дизайна.
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { createHead } from '@unhead/vue/client';
import App from './App.vue';
import { routes } from './routes';
import { setRouter } from './runtime/router';
import { installGuard } from './guard';
import { installTelegramAuth } from './plugins/telegramAuth';
import { installMiniApp } from './plugins/miniApp';
import { installPwa } from './plugins/pwa';
import { afterMount, installDesignRuntime } from './plugins/designRuntime';
import { loadDivision } from './runtime/division';
import '@platform/faculties/finfac/ui/runtime/dc-base.css';
import '@/ui/base.css';

installTelegramAuth();
void start().catch(showStartupFailure);

async function start() {
  const division = await loadDivision();
  if (!division) throw new Error('Faculty configuration is unavailable');
  const isSnimk = division?.appearance === 'snimk';
  if (isSnimk) {
    await import('@platform/faculties/snimk/ui/styles/main.css');
  }

  const appRoutes = isSnimk
    ? (await import('@platform/faculties/snimk/ui/routes')).routes
    : routes;

  const router = createRouter({
    history: createWebHistory(),
    routes: appRoutes,
    scrollBehavior: (_to, _from, saved) => saved ?? { top: 0 },
  });
  setRouter(router);
  installGuard(router);
  if (!isSnimk) installDesignRuntime(router);

  const app = createApp(App);
  app.use(router);
  app.use(createHead({ init: [{ title: 'Студенческий совет', htmlAttrs: { lang: 'ru' } }] }));
  router.isReady().then(() => {
    app.mount('#app');
    installMiniApp(router);
    installPwa();
    if (!isSnimk) afterMount();
  });
}

function showStartupFailure() {
  const root = document.getElementById('app');
  if (!root) return;
  const panel = document.createElement('main');
  panel.setAttribute('role', 'alert');
  panel.style.cssText = 'max-width:32rem;margin:15vh auto;padding:1.5rem;font:1rem/1.6 system-ui';
  const heading = document.createElement('h1');
  heading.textContent = 'Не удалось загрузить портал';
  const explanation = document.createElement('p');
  explanation.textContent = 'Проверьте соединение и повторите загрузку. Если ошибка сохраняется, обратитесь к администратору.';
  const retry = document.createElement('button');
  retry.type = 'button';
  retry.textContent = 'Повторить загрузку';
  retry.style.cssText = 'min-height:44px;padding:.5rem 1rem;cursor:pointer';
  retry.addEventListener('click', () => window.location.reload());
  panel.append(heading, explanation, retry);
  root.replaceChildren(panel);
}
